'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var getPath = exports.getPath = function getPath(state) {
  return state.router.route.path;
};

var getRouter = exports.getRouter = function getRouter(state) {
  return state.router;
};

var getSearch = exports.getSearch = function getSearch(state) {
  return state.router.route.options.q || '';
};